<template>
  <div id="contact-page">

    <div class="flex justify-end mt-8">
      <router-link to="/address-books" type="button" class="btn btn-outline-secondary w-24">返回</router-link>
    </div>

    <div v-if="checkPermission(permissions, 'site.phone_directory.view')" class="mt-2">
      <div v-if="data != null" class="intro-y xl:w-3/5 p-5 box">

        <div class="flex justify-center">
          <div class="profile-image image-fit">
            <img alt="" :src="data.user.avatar_url ?? '/images/user.png'" class="tooltip rounded-full">
          </div>
        </div>

        <div v-if="checkPermission(permissions, 'system.user.view')" class="mt-14">
          <div class="sm:grid grid-cols-2 gap-2">
            <div>
              <label for="staff-number" class="form-label">職員編號</label>
              <div class="w-full">{{ data.user.staff_number }}</div>
            </div>

            <div>
              <label class="form-label">用戶登入名稱</label>
              <div class="w-full">{{ data.user.username }}</div>
            </div>
          </div>
        </div>

        <div class="col-span-11 alert alert-primary alert-dismissible show flex items-center mb-6 mt-6" role="alert">
          <span class="font-medium">基本資料</span>
        </div>

        <div class="mt-3">
          <div class="sm:grid grid-cols-2 gap-2">
            <div>
              <label for="centre_id" class="form-label">所屬部/組/服務單位</label>
              <div class="w-full">{{ data.user.centre ? data.user.centre.abbrev : '-' }}</div>
            </div>

            <div>
              <label for="position_id" class="form-label">職位</label>
              <div class="w-full">{{ data.user.position ? data.user.position.name : '-' }}</div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div class="flex">
            <div class="flex-1 mr-1">
              <label class="form-label">主任級或以上</label>
              <div class="w-full">{{ data.user.is_high_level ? '是' : '否' }}</div>
            </div>
            <div class="flex-1 ml-1">
              <label class="form-label">註冊社工</label>
              <div class="w-full">{{ data.user.is_register_social_worker ? '是' : '否' }}</div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <label class="form-label">稱謂</label>
          <div class="w-full">{{ data.user.honorific_title ? getObjectValue(titles, 'value', data.user.honorific_title, 'key') : '-' }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">中文名稱</label>
          <div class="w-full">{{ isEmpty(data.user.full_name_zh) }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">英文名稱</label>
          <div class="w-full">{{ isEmpty(data.user.full_name) + ' ' + checkTextEmpty(data.user.other_name_en) }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">顯示名稱</label>
          <div class="w-full">{{ data.user.display_name ?? '-' }}</div>
        </div>

        <div class="flex justify-between mt-3">
          <div class="flex-1">
            <label class="form-label">電郵地址</label>
            <div class="w-full">{{ isEmpty(data.user.email)}}</div>
          </div>

          <div v-if="checkPermission(permissions, 'system.user.view')" class="flex-1">
            <label class="form-label">帳戶狀態</label>
            <div v-if="!data.user.is_effective || data.user.deleted_at != null" class="flex items-center justify-start text-warning">
              <font-awesome-icon icon="fa-regular fa-circle-xmark" />
              <div class="ml-2">無效</div>
            </div>
            <div v-else class="flex items-center justify-start text-success">
              <font-awesome-icon icon="fa-regular fa-square-check" />
              <div class="ml-2">生效</div>
            </div>
          </div>
        </div>

        <div class="mt-3 flex">
          <div class="flex-1">
            <label for="staff_number" class="form-label">辦公室電話</label>
            <div class="w-full">{{ data.user.office_number ?? '-' }}</div>
          </div>
          <div class="flex-1">
            <label for="cost_centre_code" class="form-label">傳真</label>
            <div class="w-full">{{ data.user.fax ?? '-' }}</div>
          </div>
        </div>

        <div class="mt-3 flex">
          <div class="flex-1">
            <label for="staff_number" class="form-label">手提電話</label>
            <div class="w-full">{{ data.user.contact_number ?? '-' }}</div>
          </div>
          <div class="flex-1">
            <label for="cost_centre_code" class="form-label">其他電話</label>
            <div class="w-full">{{ data.user.other_number ?? '-' }}</div>
          </div>
        </div>

        <div v-if="checkPermission(permissions, 'system.user.edit')" class="mt-3">
          <label class="form-label">出生日期</label>
          <div class="w-full">{{ data.user.birthdate ?? '-' }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">專長</label>
          <div class="w-full">{{ data.user.special_skill ?? '-' }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">關於我</label>
          <div class="w-full">{{ data.user.about_me ?? '-' }}</div>
        </div>

        <div class="col-span-11 alert alert-primary alert-dismissible show flex items-center mb-6 mt-6" role="alert">
          <span class="font-medium">其他資料</span>
        </div>

        <div class="mt-5">
          <label class="form-label">個人網站</label>
          <a v-if="data.user.personal_website" :href="getValidUrl(data.user.personal_website)" target="_blank" class="w-full block text-primary">{{ data.user.personal_website }}</a>
          <div v-else class="w-full">-</div>
        </div>

        <div class="mt-5">
          <label class="form-label">博客網站</label>
          <a v-if="data.user.blog_website" :href="getValidUrl(data.user.blog_website)" target="_blank" class="w-full block text-primary">{{ data.user.blog_website }}</a>
          <div v-else class="w-full">-</div>
        </div>

        <div class="mt-5">
          <label class="form-label">其他網站</label>
          <a v-if="data.user.other_website" :href="getValidUrl(data.user.other_website)" target="_blank" class="w-full block text-primary">{{ data.user.other_website }}</a>
          <div v-else class="w-full">-</div>
        </div>

        <div class="mt-5">
          <label class="form-label">團體及組織</label>
          <div class="w-full">{{ data.user.group ?? '-' }}</div>
        </div>

        <div class="mt-5">
          <label class="form-label">榮譽及獎項</label>
          <div class="w-full">{{ data.user.honors ?? '-' }}</div>
        </div>

        <div class="mt-5">
          <label class="form-label">榮譽及獎項</label>
          <div class="w-full">{{ data.user.honors ?? '-' }}</div>
        </div>

        <div class="mt-5">
          <label class="form-label">興趣</label>
          <div class="w-full">{{ data.user.interest ?? '-' }}</div>
        </div>

        <div class="col-span-11 alert alert-primary alert-dismissible show flex items-center mb-6 mt-6" role="alert">
          <span class="font-medium">教育</span>
        </div>

        <div class="mt-5">
          <label class="form-label">就讀學校</label>
          <div class="w-full">{{ data.user.school ?? '-' }}</div>
        </div>

        <div class="mt-5 flex">
          <div class="flex-1">
            <label for="academic" class="form-label">獲取的學歷</label>
            <div class="w-full">{{ data.user.academic ?? '-' }}</div>
          </div>

          <div class="flex-1">
            <label for="academic_department" class="form-label">學系</label>
            <div class="w-full">{{ data.user.academic_department ?? '-' }}</div>
          </div>

          <div class="flex-1">
            <label for="academic_other" class="form-label">其他資料</label>
            <div class="w-full">{{ data.user.academic_other ?? '-' }}</div>
          </div>
        </div>

        <div class="col-span-11 alert alert-primary alert-dismissible show flex items-center mb-6 mt-6" role="alert">
          <span class="font-medium">專業資格</span>
        </div>

        <div class="mt-5 flex">
          <div class="flex-1">
            <label for="professional_qualifications" class="form-label">持有的專業資格</label>
            <div class="w-full">{{ data.user.professional_qualifications ?? '-' }}</div>
          </div>

          <div class="flex-1">
            <label for="qualification_authority" class="form-label">頒發機構全名</label>
            <div class="w-full">{{ data.user.qualification_authority ?? '-' }}</div>
          </div>

          <div class="flex-1">
            <label for="qualification_level" class="form-label">已達到的程度</label>
            <div class="w-full">{{ data.user.qualification_level ?? '-' }}</div>
          </div>
        </div>

        <div class="col-span-11 alert alert-primary alert-dismissible show flex items-center mb-6 mt-6" role="alert">
          <span class="font-medium">工作經驗</span>
        </div>

        <div class="mt-5 flex">
          <div class="flex-1">
            <label for="past_company" class="form-label">公司名稱</label>
            <div class="w-full">{{ data.user.past_company ?? '-' }}</div>
          </div>

          <div class="flex-1">
            <label for="past_position" class="form-label">職位</label>
            <div class="w-full">{{ data.user.past_position ?? '-' }}</div>
          </div>

          <div class="flex-1">
            <label for="past_intro" class="form-label">描述</label>
            <div class="w-full">{{ data.user.past_intro ?? '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>

    <div v-if="false && checkPermission(permissions, 'site.phone_directory.view')" class="mt-2">
      <div v-if="data != null" class="intro-y xl:w-3/5 p-5 box">
        <div class="mt-3">
          <label for="site_id" class="form-label">分站</label>
          <div id="site_id" class="w-full" v-if="currentSite">{{ currentSite.name }}</div>
        </div>

        <div class="mt-3">
          <label for="staff_number" class="form-label">職員編號</label>
          <div class="w-full">{{ data.staff_number ?? '-' }}</div>
        </div>

        <div class="mt-3" v-if="data.user.avatar_url != null && data.user.avatar_url !== ''">
          <label for="site_id" class="form-label">大頭圖像</label>
          <img alt="大頭圖像" :src="data.user.avatar_url">
        </div>

        <div class="mt-3">
          <div class="flex">
            <div class="flex-1 mr-1">
              <label for="last_name" class="form-label">所屬部/組/服務單位</label>
              <div class="w-full">{{ data.user.centre ? data.user.centre.abbrev : '-' }}</div>
            </div>
            <div class="flex-1 ml-1">
              <label for="last_name" class="form-label">職位</label>
              <div class="w-full">{{ data.user.position ? data.user.position.name : '-' }}</div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div class="flex">
            <div class="flex-1 mr-1">
              <label for="last_name" class="form-label">主任級或以上</label>
              <div class="w-full">{{ data.is_high_level ? '是' : '否' }}</div>
            </div>
            <div class="flex-1 ml-1">
              <label for="last_name" class="form-label">註冊社工</label>
              <div class="w-full">{{ data.is_register_social_worker ? '是' : '否' }}</div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <label class="form-label">稱謂</label>
          <div class="w-full">{{ getObjectValue(titles, 'value', data.honorific_title, 'key') }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">中文名稱</label>
          <div class="w-full">{{ isEmpty(data.full_name_zh) }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">英文名稱</label>
          <div class="w-full">{{ isEmpty(data.full_name) + ' ' + checkTextEmpty(data.other_name) }}</div>
        </div>

        <div class="mt-3">
          <label class="form-label">顯示名稱</label>
          <div class="w-full">{{ data.display_name ?? '-' }}</div>
        </div>

        <div class="mt-3">
          <label for="last_name" class="form-label">電郵地址</label>
          <div>
            <div class="w-full">{{ data.user.email ?? '-' }}</div>
          </div>
        </div>

        <div class="mt-3">
          <div class="flex">
            <div class="flex-1 mr-1">
              <label for="fax" class="form-label">辦公室電話</label>
              <div class="w-full">{{ data.user.office_number ?? '-' }}</div>
            </div>
            <div class="flex-1 ml-1">
              <label for="fax" class="form-label">傳真</label>
              <div class="w-full">{{ data.fax ?? '-' }}</div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div class="flex">
            <div class="flex-1 mr-1">
              <label for="fax" class="form-label">手提電話</label>
              <div class="w-full">{{ data.user.contact_number ?? '-' }}</div>
            </div>
            <div class="flex-1 ml-1">
              <label for="fax" class="form-label">其他電話</label>
              <div class="w-full">{{ data.user.other_number ?? '-' }}</div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <label for="last_name" class="form-label">出生日期</label>
          <div class="w-full">{{ data.birthdate ? ( $moment(data.birthdate).format('YYYY年MM月DD日') ?? '-' ) : '-' }}</div>
        </div>

        <div class="mt-3">
          <label for="last_name" class="form-label">地址</label>
          <div class="w-full">{{ data.address ?? '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'currentSite', 'permissions'],
  data() {
    return {
      mounted: false,
      data: null,
      user: null,

      titles: [
        {
          key: '先生',
          value: 'Mr'
        },
        {
          key: '太太',
          value: 'Mrs'
        },
        {
          key: '小姐',
          value: 'Miss'
        },
        {
          key: '女士',
          value: 'Ms'
        },
        {
          key: '夫人',
          value: 'Madam'
        },
        {
          key: '博士',
          value: 'Dr'
        }
      ]
    }
  },
  computed: {
    serverUrl() {
      return '' + process.env.VUE_APP_SERVER_URL
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    async currentSite(val) {
      await this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite) {
        await this.loadData()

        this.mounted = true
      }
    },
    async loadData() {
      this.data = await this.getSiteContact(this.currentSite.site_id, this.$route.params.contactId)
    },
    isEmpty(val) {
      return (val != null && val !== '' ? val : '-')
    }
  }
}
</script>

<style lang="scss" scoped>
#contact-page {
  .leading-relaxed {
    min-height: 400px;
  }

  .profile-image {
    width: 100px;
    height: 100px;
  }
}
</style>
